import palette from './colors.json';

const COLORS = palette;

export const applyColorsToRoot = () => {
  const root = document.documentElement;
  Object.entries(COLORS).forEach(([key, value]) => {
    root.style.setProperty(`--color-${key}`, value);
  });
};

export default COLORS;
